// =============================================================================
// Origin UI — src/services/helpApi.ts
// Typed API calls for the AI Help Assistant chat and feedback endpoints.
// =============================================================================

import { api } from './apiService';

export interface ChatMessageDto {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatResponseDto {
  response: string;
}

export interface FeedbackRequestDto {
  userQuestion: string;
  assistantResponse: string;
}

export const helpApi = {
  sendMessage: (message: string, conversationHistory: ChatMessageDto[]) =>
    api.post<ChatResponseDto>('/api/help/chat', { message, conversationHistory }),

  submitFeedback: (userQuestion: string, assistantResponse: string) =>
    api.post<void>('/api/help/feedback', { userQuestion, assistantResponse } as FeedbackRequestDto),
};
